import styles from "./Proposition.module.scss";
import { HorizontalLine } from "../../atoms/divider/Divider";
import { H4, Body } from "../../atoms/text/Text";
import PropTypes from "prop-types";
import { createMarkup } from "../../../utils/helperServices";
import Image from "../../atoms/image/image";
import { Container, CustomContainer } from "../../atoms/DependencyHelper";

const Proposition = ({ align, onClick, isActive, data = {}, showIcon, isStatic }) => {
  return (
    <Container
      className={`
      ${styles["proposition"]}
      ${align === "right" ? "align-items-end" : "align-items-start"}
      ${isActive && styles["proposition--active"]}
      ${isStatic && styles["proposition--static"]}
      `}
      onClick={onClick}
      id={data.id}
      data-cms-title={data.analyticTitle}
    >
      {showIcon && data.icon && (
        <Image img_path={data.icon} className={styles["proposition__icon"]} />
      )}
      <H4 color={"inherit"} textAlign={align} width="100%" fontFamily="'Roboto Bold', Arial, Helvetica, sans-serif" className={styles["proposition__title"]}>
        {data.title}
      </H4>
      <CustomContainer
        className={`d-flex p-0 ${
          align === "right" ? "justify-content-end" : "justify-content-start"
        }`}
      >
        <HorizontalLine
          className={styles["proposition__divider"]}
          width="3rem"
        />
      </CustomContainer>

      <Body
        dangerouslySetInnerHTML={createMarkup(data.description)}
        color={"inherit"}
        textAlign={align}
        lineHeight="1.5"
        width="100%"
        fontFamily="'Roboto Regular', Arial, Helvetica, sans-serif"
      ></Body>
    </Container>
  );
};

Proposition.propTypes = {
  align: PropTypes.string,
  onClick: PropTypes.func,
  data: PropTypes.shape({
    icon: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  isActive: PropTypes.bool,
  showIcon: PropTypes.bool,
  isStatic: PropTypes.bool
};

Proposition.defaultProps = {
  data: { icon: null, heading: null, description: null },
  showIcon: true,
};

export default Proposition;
